import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { LocalCache } from '@nk/caching-lib';
import { CompanyEventEntity, EventEntity } from '@nk/data-entities-lib';

export interface CompanyEventApiService {
  companyEventCache: LocalCache<
    CompanyEventApiService,
    (companyEventUuid: string, skipSensitiveDataClaim?: boolean) => Observable<CompanyEventEntity>
  >;
  eventCache: LocalCache<
    CompanyEventApiService,
    (eventUuid: string, skipSensitiveDataClaim?: boolean) => Observable<EventEntity>
  >;
}

export const COMPANY_EVENT_API_SERVICE_TOKEN = new InjectionToken<CompanyEventApiService>('CompanyEventApiService');
